import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"
import App from '@/components/App.vue'
import Login from '@/components/Login.vue'
import i18n from '@/locales/i18n'; // adjust path as needed
import '@/utils/axios' // Initialize axios interceptor for locale headers
import "@/index.css";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(pinia)
app.use(i18n)
app.mount('#app')


const login = createApp(Login)
login.use(pinia);
login.use(i18n)
login.mount('#login')

